import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useLanguage } from "../../../../Translations/LenguageContext";
import ErrorMessage from "../../../../Components/ErrorMessage";
import { getSnippet } from "./Snippets";
import { useParams } from "react-router-dom";
import { BiCopy } from "react-icons/bi";

const APIConnectorModal = ({ show, handleClose, collectionDetails, db_id, region }) => {
    const { t } = useLanguage();
    const user_id = sessionStorage.getItem("user_id");
    const {project_id} = useParams()
    const [copiedSnippet, setCopiedSnippet] = useState(false);
    const [copiedUrl, setCopiedUrl] = useState(false);
    const [configSnippet, setConfigSnippet] = useState("");
    const [selectedLang, setSelectedLang] = useState("python");
    const [error, setError] = useState({ message: "", display: false });
    const [url, setUrl] = useState(null);

    useEffect(() => {
        if (collectionDetails && user_id && db_id) {
            const coll_id = collectionDetails.coll_id;
            const snippet = getSnippet(selectedLang, user_id,project_id, db_id, coll_id, region);
            // setUrl(`http://127.0.0.1:5000/${user_id}/YOUR_API_KEY/${db_id}/${coll_id}/YOUR_CRUD_OPERATION`);
            setUrl(`https://api.erioon.com/${user_id}/${project_id}/${db_id}/${region}/${coll_id}/connection_ping`);
            setConfigSnippet(snippet);
        }
    }, [show, collectionDetails, db_id, user_id, selectedLang]);

    const handleCopySnippetClick = () => {
        const text = configSnippet.replace(/<[^>]*>/g, ''); 
        navigator.clipboard.writeText(text);
        setCopiedSnippet(true);
        setTimeout(() => setCopiedSnippet(false), 2000); 
    };

    const handleCopyUrlClick = () => {
        navigator.clipboard.writeText(url);
        setCopiedUrl(true);
        setTimeout(() => setCopiedUrl(false), 2000); 
    };

    const CloseModal = () => {
        setConfigSnippet("");
        handleClose();
        setError({ message: "", display: false });
    };

    return (
        <Modal show={show} onHide={CloseModal} className="modal_api_connection">
            <div className="share_main_cont_modal">
                <p className="share_label">Test API connection example</p>
                <div className="share_link_cont_modal">
                    <div className="warning_delete_message">
                        <p>Use the following code to test the connection with your collection. <br/>For more information read the <a href="https://www.erioon.com/dev-docs/py-sdk-db">Developer documentation</a></p>
                        <p><strong><i className="fa-solid fa-warning"></i> Replace YOUR_API_KEY with your actual API key.</strong></p>
                    </div>
                    <div className="code_snippet_container">
                        <div className="code_snippet_container_btn_cont">
                            {/* {["python", "javascript", "curl"].map(lang => (
                                <button
                                    key={lang}
                                    className={`code_snippet_container_button ${selectedLang === lang ? "active" : ""}`}
                                    onClick={() => setSelectedLang(lang)}
                                >
                                    {lang === "javascript" ? "Javascript" :
                                        lang === "python" ? "Python" :
                                            lang === "curl" ? "cURL" : lang}
                                </button>
                            ))} */}
                        </div>
                        <pre className="code_snippet_block">
                            <div className="header_code_snippet_block">
                                <p>Snippet <strong>.ping()</strong> in {selectedLang === "javascript" ? "Javascript" :
                                    selectedLang === "python" ? "Python" :
                                        selectedLang === "curl" ? "cURL": selectedLang}</p>
                                <button className="copy_clipboard_link_file_btn_code" onClick={handleCopySnippetClick}>
                                    {copiedSnippet ? <i className="fa-solid fa-check"></i> : <BiCopy />}
                                </button>
                            </div>
                            <code dangerouslySetInnerHTML={{ __html: configSnippet }}></code>
                        </pre>

                        <p className="db_title">Connection URL for REST API -<code>GET</code></p>
                        <div className="link_cont_file_share">
                            <div className="link_file">
                                <p>
                                    {url ? (
                                        <span>{url}</span>
                                    ) : (
                                        <div className="loading_link_container"></div>
                                    )}
                                </p>
                            </div>
                            <button className="copy_clipboard_link_file_btn" onClick={handleCopyUrlClick}>
                                {copiedUrl ? <i className="fa-solid fa-check"></i> : <BiCopy />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal_footer">
                <ErrorMessage err={error} />
                <div className="footer_btn_cont">
                    <button className="cancel_btn" onClick={CloseModal}>
                        {t.cancel}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default APIConnectorModal;
